import Script from 'next/script'

import { initScript } from '@repo/analytics/openai'
import { useOpenAiUserMatching } from '@repo/analytics/openai/use-openai-user-matching'
import { useIubendaConfig } from './iubenda'

export const OpenAiPixel = () => {
  const { scriptProps, variant } = useIubendaConfig()
  useOpenAiUserMatching()

  if (variant === 'locationNotSet') {
    return null
  }

  return (
    <Script id="openai-pixel-script" strategy="afterInteractive" {...scriptProps}>
      {initScript}
    </Script>
  )
}
